module.exports = __webpack_public_path__ + "static/manage-projects-3122348941eb6f8ec0133a9b6a517de1.png";